import type { State } from 'state';
import type { PersistedError } from 'state/persisted/types';

export const getInitialError = (state: State): PersistedError | undefined => {
    return state.persisted.visitPortal.initialError;
};

export const isLoggedInBeforeCheck = (state: State): boolean => {
    return state.persisted.visitPortal.loggedInBeforeCheck;
};

export const getEmail = (state: State): string => {
    return state.persisted.visitPortal.email;
};

export const getPortalName = (state: State): string => {
    return state.persisted.visitPortal.portalName;
};
